import produce from 'immer';
import { isChatInWaitingQueue } from '../../utils/fuctions/mapSituationChat';

const INITIAL_STATE = {
  conversations: []
};

export default function conversation(state = INITIAL_STATE, action) {
  // console.log('##### REDUCER ANSWERED CONVERSAION #####');
  switch (action.type) {
    case '@ANSWERED_CONVERSATION/ADD_INIT_CONVERSATIONS':
      return produce(state, (draft) => {
        draft.conversations = action.payload.conversations;
      });
    case '@ANSWERED_CONVERSATION/ADD_CONVERSATION':
      return produce(state, (draft) => {
        const chatId =
          action.payload.conversation?._id ?? action.payload.conversation.id;
        if (isChatInWaitingQueue(action.payload.conversation?.situacao)) {
          return;
        }
        const index = draft.conversations.findIndex(
          (c) => (c._id ?? c?.id) === chatId
        );

        if (index < 0) draft.conversations.push(action.payload.conversation);
        else draft.conversations[index] = action.payload.conversation;
      });
    case '@ANSWERED_CONVERSATION/ALTER_CONTACT_NAME':
      return produce(state, (draft) => {
        const contactId = action.payload.data?.contactId;
        const chatId = action.payload.data?.chatId;
        const newContactName = action.payload.data?.newContactName;

        if (!newContactName) return;

        if (chatId) {
          const index = draft.conversations.findIndex(
            (c) => (c?.id || c?._id) === chatId
          );
          if (index >= 0) {
            draft.conversations[index].cliente.nome =
              action.payload.data.newContactName;
            return;
          }
        }

        if (!contactId) return;

        const index = draft.conversations.findIndex(
          (c) => c?.cliente?.id === contactId
        );

        if (index < 0) return;

        draft.conversations[index].cliente.nome =
          action.payload.data.newContactName;
      });
    case '@ANSWERED_CONVERSATION/REMOVE_CONVERSATION':
      return produce(state, (draft) => {
        const conversationIndex = draft.conversations.findIndex((c) => {
          const id = c?._id ?? c.id;
          return id === action.payload.id;
        });
        if (conversationIndex >= 0) {
          draft.conversations.splice(conversationIndex, 1);
        }
      });
    case '@ANSWERED_CONVERSATION/ADD_MESSAGE_ANSWERED_CONVERSATION':
      return produce(state, (draft) => {
        const index = draft.conversations.findIndex(
          (c) => (c._id ?? c?.id) === action?.payload?.idDaConversa
        );

        if (index < 0) return;

        draft.conversations[index].mensagens.push(action.payload.message);
        draft.conversations[index].novas_mensagens =
          action.payload.novas_mensagens;
      });
    case '@ANSWERED_CONVERSATION/CHANGE_STATUS_METRICS_OF_CONVERSATION':
      return produce(state, (draft) => {
        const index = draft.conversations.findIndex(
          (c) => (c._id ?? c?.id) === action.payload.chatId
        );

        if (index < 0) return;

        draft.conversations[index].statusOfChat = action.payload.statusOfChat;
        draft.conversations[index].withResponseAgent =
          action.payload.withResponseAgent;
      });
    case '@ANSWERED_CONVERSATION/UPDATE_TAGS_ANSWERED_CONVERSATION':
      return produce(state, (draft) => {
        const index = draft.conversations.findIndex(
          (c) => c?.cliente?.id === action.payload?.contactId
        );

        if (index < 0) return;

        draft.conversations[index].tags = action.payload.newContactTag;
        draft.conversations[index].cliente.tags = action.payload.newContactTag;
      });

    default:
      return state;
  }
}
